<template>
	<div v-if="info" class="icon-list-element">
		<div class="icon" aria-hidden="true">
			<slot></slot>
		</div>
		<div class="icon-list-text">
			<div class="heading-title">
				<div class="heading-5 title">{{ title }}</div>
			</div>
			<div class="body-text-1 info">{{ info }}</div>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		info: {
			type: [String, Number],
			default: ''
		}
	}
};
</script>
<style lang="scss" scoped>
.icon-list-element {
	list-style-type: decimal;
	display: flex;
	align-items: center;

	&:not(:last-child) {
		margin-bottom: 16px;
	}

	.info {
		color: $font-header;
		text-align: left;
	}
	.title {
		color: $font-gray;
		text-align: left;
	}

	.icon {
		font-family: 'RobotoMedium';
		display: flex;
		align-items: center;
		justify-content: center;
		height: 44px;
		width: 44px;
		border-radius: 100%;
		background-color: $icon-bgcolor;
		color: $icon-color;
		margin-right: 16px;
		flex-shrink: 0;
	}
}
</style>
